import { useEffect, useState } from 'react';
import './AstrologerSlides.css';

function AstrologerSlides() {
  const slides = [
    {
      image: require('../assets/banner_slides_/consult1.jpg'),
      heading: 'Embrace the Best Astrologer Online Consultation',
      content:
        'In the digital age, wisdom knows no boundaries. Jyotishacharya Vivek Kirti brings the ancient art of astrology into the modern era. From the comfort of your home, begin your cosmic journey.',
    },
    {
      image: require('../assets/banner_slides_/consult2.jpg'),
      heading: 'Navigate Through the Stars With Guidance',
      content:
        'These sessions are not just conversations—they are transformative experiences that bring clarity, purpose, and cosmic insight into your life\'s journey.',
    },
    {
      image: require('../assets/banner_slides_/consult3.jpg'),
      heading: 'Spiritual Awakening in the Modern World',
      content:
        'We blend Vedic traditions with modern mediums to offer you authentic astrological wisdom, right at your fingertips—anytime, anywhere.',
    },
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div>
      {/* === Online Consultation Slider Section === */}
      <div
        className="slider-container"
        style={{
          backgroundImage: `url(${slides[index].image})`,
        }}
      >
        <div className="slider-overlay">
          <h2>{slides[index].heading}</h2>
          <p>{slides[index].content}</p>
        </div>
      </div>

      {/* You can continue adding next <div> sections here for Services, Zodiac, etc. */}
    </div>
  );
}

export default AstrologerSlides;
